export enum FeatureFlagsEnum {
	CHECKIN_WITH_SELFIE = 'checkin_with_selfie',
	PARAMS_TINY_FACE_DETECTOR = 'params_tiny_face_detector',
	ENABLE_TINY_FACE_DETECTOR_WITHDRAWAL = 'enable_tiny_face_detector_withdrawal',
	PARAMS_RESOLUTION_PHOTO_WITHDRAWAL = 'params_resolution_photo_withdrawal',
	ENABLE_LIVENESS = 'enable_liveness',
}
